import React from 'react';
import { makeStyles, withStyles, Theme, createStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';

const CustomTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#00ABC7',
        opacity: 1,
      },
      '&$selected': {
        color: '#00ABC7',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#00ABC7',
      },
    },
    selected: {},
  }),
)((props: CustomTabProps) => <Tab disableRipple {...props} />);

interface CustomTabProps {
  value: string;
  label: string;
}

export default CustomTab;